<template>
    <div>
        <div class="columns">
            <div class="column box is-one-third">
                <b-field label="Boss kills">
                    <b-numberinput min="0" max="400" v-model="killCount"/>
                </b-field>
                <b-field label="Decorations">
                    <b-numberinput :min="killCount" :max="killCount * 5" v-model="decorations"/>
                </b-field>

                <p>
                    There are ~{{(ratio * 100).toFixed(3)}}% people with
                    {{decorations}} decorations if they finished the encounter
                    {{killCount}} times and never used/destroyed any.
                </p>
            </div>

            <div class="column">
                <div class="title is-5">Explanation</div>
                <div class="content">
                    <p>
                        When defeating a Guild Wars 2 raid encounter for the
                        first time in a week rewards include guild decoration
                        tokens. It is possible to get from 1 up to 5 tokens per
                        week. This calculator assumes the probability of getting
                        any amount is the same (20%) which is consistent with
                        our observations.
                    </p>
                    <figure>
                        <a href="https://wiki.guildwars2.com/wiki/Dhuum%27s_Token">
                            <img src="https://render.guildwars2.com/file/2BB54BA422D3F3DA542A932BDB37A4AB17A6A6F3/1894796.png"
                                 alt="Dhuum's Token" title="Dhuum's Token" class="image is-48x48">
                        </a>
                        <figcaption>Dhuum's Token - the decoration dropped by Dhuum, the final boss in Hall of Chains</figcaption>
                    </figure>
                    <p>
                        The intended use is to craft guild statues, but they
                        are also used to show experience. This calculator can
                        be used to determine a realistic number to ask for if
                        you don't want to exclude unlucky people and avoid
                        being completely unrealistic.
                    </p>
                    <p>
                        The calculator on the left tells you what percentage of
                        people have a specified amount of decorations if they
                        have killed a boss some amount of times. You can
                        use this to see how lucky you are with your drops.
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    // Use 400 at max, around 442 the percentages get too small for javascript floats and underflow
    function calculateDistribution(kills) {
        let max = kills * 5;
        let results = new Array(max + 1).fill(0);
        results[0] = 1;
        for (let kill = 0; kill < kills; kill++) {
            let newResults = new Array(max + 1).fill(0);
            for (let i = 0; i <= max; i++) {
                let minPrev = i - 5 >= 0 ? i - 5 : 0;
                let sum = 0;
                for (let j = minPrev; j < i; j++) {
                    sum += results[j];
                }
                newResults[i] = sum;
            }
            results = newResults;
        }

        let total = results.reduce((a, b) => a + b, 0);
        let percentages = results.map(a => a / total);

        return percentages;
    }

    function percentile(distribution, value) {
        let sum = 0;
        for (let i = 0; i <= value; i++) {
            if (i >= distribution.length) {
                break;
            }
            sum += distribution[i];
        }

        return 1 - sum;
    }

    export default {
        name: 'calculators-killproof',
        data() {
            return {
                killCount: 15,
                decorations: 40
            }
        },
        computed: {
            distribution() {
                return calculateDistribution(this.killCount);
            },
            ratio() {
                return percentile(this.distribution, this.decorations);
            }
        }
    }
</script>

<style>
</style>
